"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GenericErrorState = /** @class */ (function () {
    function GenericErrorState() {
    }
    return GenericErrorState;
}());
exports.default = GenericErrorState;
//# sourceMappingURL=GenericErrorState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/GenericError/GenericErrorState.js
// module id = 1684
// module chunks = 8